var tns = require('tiny-slider').tns;

document.addEventListener('DOMContentLoaded', function () {
  function isMobile() {
    return window.innerWidth <= 768;
  }

  if (isMobile() && document.querySelector('.blog-overview__slider')) {
    var wrapper = document.querySelector('.blog-overview__slider-wrapper');
    var slider = tns({
      container: '.blog-overview__slider',
      items: 1,
      slideBy: 'page',
      loop: false,
      controls: false,
      nav: false,
      gutter: 16,
      mouseDrag: true,
      responsive: {
        0: { items: 1 },
        480: { items: 1 },
        768: { items: 1 }
      }
    });

    var prevBtn = wrapper.querySelector('.slider-prev');
    var nextBtn = wrapper.querySelector('.slider-next');

    function updateButtons() {
      var info = slider.getInfo();
      var atStart = info.index === info.cloneCount;
      var atEnd = info.index >= info.slideCount + info.cloneCount - info.items;
      prevBtn.classList.toggle('disabled', atStart);
      nextBtn.classList.toggle('disabled', atEnd);
    }

    if (prevBtn && nextBtn) {
      updateButtons();
      slider.events.on('indexChanged', updateButtons);

      prevBtn.addEventListener('click', function () {
        if (!prevBtn.classList.contains('disabled')) slider.goTo('prev');
      });
      nextBtn.addEventListener('click', function () {
        if (!nextBtn.classList.contains('disabled')) slider.goTo('next');
      });
    }
  }
});
